import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PrivacyPoliciesComponent} from './privacy-policies.component';

const routes: Routes = [
    {
        path: 'privacy-policies',
        component: PrivacyPoliciesComponent,
        data: {animation: 'privacy-policies'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrivacyPoliciesRoutingModule {
}
